import type { SVGProps } from "react";
export default function SvgResearchAppNoShadow(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 112 112"
			{...props}
		>
			<foreignObject width={102.669} height={102.669} x={-4.00195} y={13.3311}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_0_1110_691_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter0_i_1110_691)">
				<path
					fill="url(#paint0_linear_1110_691)"
					fillOpacity={0.6}
					d="M47.334 31.331h-.003c-18.41 0-33.333 14.924-33.333 33.333v.003C13.998 83.077 28.922 98 47.331 98h.003c18.41 0 33.333-14.924 33.333-33.333v-.003c0-18.41-14.924-33.333-33.333-33.333"
				/>
				<path
					stroke="url(#paint1_linear_1110_691)"
					d="M47.331 31.831h.003c18.133 0 32.833 14.7 32.833 32.833v.003c0 18.133-14.7 32.833-32.833 32.833h-.003c-18.133 0-32.833-14.7-32.833-32.833v-.003l.01-.848c.443-17.46 14.516-31.532 31.975-31.974z"
				/>
			</g>
			<foreignObject width={106.22} height={106.22} x={7.23926} y={-1.46875}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_1_1110_691_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter1_i_1110_691)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M60.35 16.531c19.377 0 35.11 15.732 35.11 35.11S79.726 86.75 60.35 86.75c-19.379 0-35.11-15.733-35.11-35.11 0-19.378 15.731-35.11 35.11-35.11"
				/>
				<path
					stroke="url(#paint2_linear_1110_691)"
					strokeOpacity={0.5}
					d="M60.35 17.031c19.1 0 34.609 15.508 34.609 34.61 0 19.1-15.508 34.61-34.61 34.61-19.101 0-34.61-15.509-34.61-34.61 0-19.102 15.51-34.61 34.61-34.61Z"
				/>
			</g>
			<path
				fill="#FAFF00"
				stroke="url(#paint3_linear_1110_691)"
				d="M60.353 40.907c5.93 0 10.738 4.808 10.738 10.739 0 5.93-4.807 10.738-10.738 10.738s-10.739-4.808-10.739-10.739c0-5.93 4.808-10.738 10.739-10.738Z"
			/>
			<path
				fill="#F5FCFF"
				d="M60.35 78.013c-14.537 0-26.362-11.825-26.362-26.361S45.813 25.291 60.35 25.291s26.36 11.825 26.36 26.361-11.824 26.361-26.36 26.361m0-48.07c-11.972 0-21.71 9.74-21.71 21.709s9.738 21.71 21.71 21.71c11.971 0 21.709-9.741 21.709-21.71s-9.74-21.71-21.71-21.71"
			/>
			<path
				stroke="url(#paint4_linear_1110_691)"
				strokeOpacity={0.5}
				d="M60.35 25.791c14.26 0 25.86 11.601 25.86 25.861s-11.6 25.86-25.86 25.86-25.861-11.6-25.862-25.86S46.09 25.791 60.35 25.791Zm0 3.651c-12.248 0-22.21 9.966-22.21 22.21s9.962 22.21 22.21 22.21c12.247 0 22.208-9.965 22.209-22.21 0-12.244-9.965-22.21-22.21-22.21Z"
			/>
			<foreignObject width={75.9756} height={75.9756} x={40.0264} y={-4}>
				<div
					style={{
						backdropFilter: "blur(9px)",
						clipPath: "url(#bgblur_2_1110_691_clip_path)",
						height: "100%",
						width: "100%",
					}}
				/>
			</foreignObject>
			<g data-figma-bg-blur-radius={18} filter="url(#filter2_i_1110_691)">
				<path
					fill="white"
					fillOpacity={0.01}
					d="M97.828 22.563a2.01 2.01 0 0 0-1.926-1.196l-5.517.25.25-5.517a2.01 2.01 0 0 0-3.427-1.513l-8.74 8.74a2 2 0 0 0-.587 1.42v6.084L58.708 50.005a2.325 2.325 0 1 0 3.289 3.289L81.17 34.12h6.084c.532 0 1.044-.212 1.42-.589l8.74-8.74a2.01 2.01 0 0 0 .417-2.231z"
				/>
				<path
					stroke="url(#paint5_linear_1110_691)"
					strokeOpacity={0.5}
					d="M87.562 14.941a1.51 1.51 0 0 1 1.674-.314c.536.238.882.758.9 1.334v.116l-.25 5.518-.026.547.547-.026 5.518-.25a1.51 1.51 0 0 1 1.445.898l.038.086c.202.55.07 1.17-.347 1.587l-8.74 8.74a1.5 1.5 0 0 1-1.067.443h-6.291l-.147.147L61.644 52.94a1.82 1.82 0 0 1-1.291.536 1.825 1.825 0 0 1-1.291-3.117l19.32-19.32v-6.291c0-.4.157-.785.44-1.067z"
				/>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_1110_691"
					x1={47.5026}
					x2={47.5026}
					y1={31.3311}
					y2={97.9997}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={1} stopColor="#BBD3DD" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_1110_691"
					x1={47.3326}
					x2={22.7167}
					y1={32.0612}
					y2={86.7656}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="white" />
					<stop offset={0.519231} stopColor="#A6BEC4" />
					<stop offset={1} stopColor="white" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_1110_691"
					x1={60.3492}
					x2={60.3492}
					y1={16.5312}
					y2={86.7506}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_1110_691"
					x1={50.2434}
					x2={76.7463}
					y1={39.7147}
					y2={52.8914}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" stopOpacity={0.2} />
					<stop offset={1} stopColor="#F5FCFF" stopOpacity={0.05} />
				</linearGradient>
				<linearGradient
					id="paint4_linear_1110_691"
					x1={60.3495}
					x2={60.3495}
					y1={25.291}
					y2={78.013}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_1110_691"
					x1={78.0141}
					x2={78.0141}
					y1={14}
					y2={53.9752}
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F5FCFF" />
					<stop offset={0.509653} stopColor="#B1D2DB" />
					<stop offset={1} stopColor="#F5FCFF" />
				</linearGradient>
				<clipPath id="bgblur_0_1110_691_clip_path" transform="translate(4.002 -13.331)">
					<path d="M47.334 31.331h-.003c-18.41 0-33.333 14.924-33.333 33.333v.003C13.998 83.077 28.922 98 47.331 98h.003c18.41 0 33.333-14.924 33.333-33.333v-.003c0-18.41-14.924-33.333-33.333-33.333" />
				</clipPath>
				<clipPath id="bgblur_1_1110_691_clip_path" transform="translate(-7.24 1.469)">
					<path d="M60.35 16.531c19.377 0 35.11 15.732 35.11 35.11S79.726 86.75 60.35 86.75c-19.379 0-35.11-15.733-35.11-35.11 0-19.378 15.731-35.11 35.11-35.11" />
				</clipPath>
				<clipPath id="bgblur_2_1110_691_clip_path" transform="translate(-40.026 4)">
					<path d="M97.828 22.563a2.01 2.01 0 0 0-1.926-1.196l-5.517.25.25-5.517a2.01 2.01 0 0 0-3.427-1.513l-8.74 8.74a2 2 0 0 0-.587 1.42v6.084L58.708 50.005a2.325 2.325 0 1 0 3.289 3.289L81.17 34.12h6.084c.532 0 1.044-.212 1.42-.589l8.74-8.74a2.01 2.01 0 0 0 .417-2.231z" />
				</clipPath>
				<filter
					id="filter0_i_1110_691"
					width={102.669}
					height={102.669}
					x={-4.00195}
					y={13.3311}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_691" />
				</filter>
				<filter
					id="filter1_i_1110_691"
					width={106.22}
					height={106.22}
					x={7.23926}
					y={-1.46875}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_691" />
				</filter>
				<filter
					id="filter2_i_1110_691"
					width={75.9756}
					height={75.9756}
					x={40.0264}
					y={-4}
					colorInterpolationFilters="sRGB"
					filterUnits="userSpaceOnUse"
				>
					<feFlood floodOpacity={0} result="BackgroundImageFix" />
					<feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
					<feColorMatrix
						in="SourceAlpha"
						result="hardAlpha"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					/>
					<feOffset dy={-1} />
					<feGaussianBlur stdDeviation={2.5} />
					<feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
					<feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
					<feBlend in2="shape" result="effect1_innerShadow_1110_691" />
				</filter>
			</defs>
		</svg>
	);
}
